// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1nmz9jpi{word-break:break-all}\n._o5726vc6{white-space:pre-line}", ""]);
// Exports
module.exports = exports;
